import React from "react";
import { DriversList, DriversRow } from "../api";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";

export interface DriverPulldownState {
    selectedDriver: DriversRow | null;
    initWithNull: boolean;
    driverCompleteData: any;
    title?: string;
    onChange: (driver: any) => void;
    onClear: () => void;
}

export const DriverPulldown: React.FC<
    DriverPulldownState & { className?: string; m?: number }
> = (props: DriverPulldownState) => {
    function onChangeDriver(event: any, selectedDriver: null | DriversRow) {
        if (props.onChange) {
            props.onChange(selectedDriver);
        }
    }

    const options =
        props.driverCompleteData && props.driverCompleteData.drivers
            ? props.driverCompleteData.drivers
            : [];

    const defaultProps = {
        options: options,
        getOptionLabel: (option: any) => option.driverName,
    };

    const autoCompInitValue = props.initWithNull ? null : props.selectedDriver;

    return (
        <Stack spacing={1} sx={{ width: 240 }}>
            <Autocomplete
                value={autoCompInitValue}
                {...defaultProps}
                onChange={onChangeDriver}
                title="乗務員名"
                clearOnEscape
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="乗務員選択"
                        size="small"
                        variant="filled"
                    />
                )}
            />
        </Stack>
    );
};
